export const FirebaseUserDefaultData = {
  question: '',
  option1: '',
  option2: '',
  option3: '',
  option4: '',
  option1_count: 0,
  option2_count: 0,
  option3_count: 0,
  option4_count: 0,
  created_by: '',
  created_at: '',
  isAnonymous: false,
  answered_by: [],
  is_expired: false,
}